import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDaysIcon, CameraIcon, MegaphoneIcon, RadioIcon, VideoIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
const SERVICES = [{
  num: '01',
  icon: VideoIcon,
  title: 'Filmación Corporativa',
  desc: 'Videos institucionales, presentaciones, contenido para redes.'
}, {
  num: '02',
  icon: CalendarDaysIcon,
  title: 'Cobertura de Eventos',
  desc: 'Eventos en vivo, conferencias, lanzamientos corporativos.'
}, {
  num: '03',
  icon: MegaphoneIcon,
  title: 'Producción Publicitaria',
  desc: 'Spots, campañas digitales, contenido para TV y streaming.'
}, {
  num: '04',
  icon: RadioIcon,
  title: 'Transmisión en Vivo',
  desc: 'Streaming profesional, pantallas LED, multicámara.'
}, {
  num: '05',
  icon: CameraIcon,
  title: 'Fotografía Corporativa',
  desc: 'Sesiones de marca, productos, equipo, eventos.'
}];
export function Services() {
  return <section id="servicios" className="w-full bg-vm-bg py-28 lg:py-36" data-id="element-154" data-mp="36c7qqb05cup8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10" data-id="element-155" data-mp="3b36ajkkcgax8">
        <div className="max-w-4xl" data-id="element-156" data-mp="3b4r354n3ljsg">
          <SectionLabel data-id="element-157" data-mp="2xbrrxeucmbqp">Servicios</SectionLabel>
          <h2 className="mt-6 font-syne text-4xl font-bold leading-[1.03] text-white sm:text-5xl lg:text-[56px]" data-id="element-158" data-mp="2xd2td80bn7en">
            Todo lo que necesitás para comunicar tu marca
          </h2>
        </div>

        <div className="mt-16 border-t border-white/20" data-id="element-159" data-mp="3q1rx7esrhqu3">
          {SERVICES.map((service, index) => {
          const Icon = service.icon;
          return <motion.article key={service.num} initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.06
          }} className="group grid grid-cols-1 gap-4 border-b border-white/20 py-9 transition-colors sm:grid-cols-12 sm:items-center sm:gap-8 lg:py-12" data-id="element-160" data-mp="3g2smzrscln4z" data-mpi={index}>
                <div className="flex items-center gap-5 sm:col-span-3" data-id="element-161" data-mp="1pm6vnbqi6qmr">
                  <span className="font-syne text-5xl font-extrabold leading-none text-vm-sky lg:text-6xl" data-id="element-162" data-mp="1lj0uujm5trno">
                    {service.num}
                  </span>
                  <Icon className="h-8 w-8 text-vm-sky sm:h-9 sm:w-9" strokeWidth={1.5} aria-hidden="true" data-id="element-163" data-mp="1bt7gjaumuyfq" />
                </div>
                <h3 className="font-syne text-2xl font-semibold uppercase leading-tight text-white transition-colors group-hover:text-vm-sky sm:col-span-4 lg:text-[28px]" data-id="element-164" data-mp="16ue83wu7dxmf">
                  {service.title}
                </h3>
                <p className="font-light leading-relaxed text-vm-muted sm:col-span-5 sm:text-lg" data-id="element-165" data-mp="xv0v4u6veqwy">{service.desc}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}